export default {
  label: '中级程序员',
  id: '0',
  children: [
    {
      label: '定义',
      id: '0-1',
      children: [
        {
          label: '能独立负责模块开发的骨干。',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '职责',
      id: '0-2',
      children: [
        {
          label: '独立完成复杂任务，解决常见问题，优化代码质量，参与模块级设计。',
          id: '0-2-1',
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备扎实的编程能力，熟悉系统架构设计，能够独立完成技术方案评估和优化。',
          id: '0-3-1',
        },
      ],
    },
    {
      label: '职业发展',
      id: '0-4',
      children: [
        {
          label: '通常在3-5年后晋升为高级程序员或技术专家。',
          id: '0-4-1',
        },
      ],
    },
    {
      label: '薪资水平',
      id: '0-5',
      children: [
        {
          label: '月薪在10,000元至20,000元之间。',
          id: '0-5-1',
        },
      ],
    },
  ],
};